import { render, staticRenderFns } from "./PostCallThanks.vue?vue&type=template&id=6671b7a2&lang=pug&"
import script from "./PostCallThanks.vue?vue&type=script&lang=js&"
export * from "./PostCallThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports